// TelcoTrack - Status Badge Component
// Reusable status badge with design-token fills (see status-badge.component.scss).

import { Component, Input } from '@angular/core';
import type { ObjectStatusBadgeType } from '../../../../core/shared-bridge';

export type StatusType = ObjectStatusBadgeType | 'success' | 'warning' | 'error' | 'info' | 'neutral';

const STATUS_TONE_CLASS: Record<StatusType, string> = {
  'no-info': 'tt-status-badge--no-info',
  'in-progress': 'tt-status-badge--in-progress',
  complete: 'tt-status-badge--complete',
  success: 'tt-status-badge--success',
  warning: 'tt-status-badge--warning',
  error: 'tt-status-badge--error',
  info: 'tt-status-badge--info',
  neutral: 'tt-status-badge--neutral',
};

@Component({
  selector: 'app-status-badge',
  template: `
    <span [class]="badgeClasses">
      <ng-content></ng-content>
    </span>
  `,
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent {
  @Input() status: StatusType = 'info';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() customText: string = '';

  get badgeClasses(): string {
    const sizeClass =
      this.size === 'sm'
        ? 'tt-status-badge--sm'
        : this.size === 'lg'
          ? 'tt-status-badge--lg'
          : 'tt-status-badge--md';
    const toneClass = STATUS_TONE_CLASS[this.status] || STATUS_TONE_CLASS.info;
    return `tt-status-badge ${sizeClass} ${toneClass}`;
  }
}
